/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Component, Input, OnInit } from "@angular/core";
import { BehaviorSubject } from "rxjs";

import { DirectoryItemModel } from "../../models/directory-item.model";
import { GoogleMapService } from "../google-map/google-map.service";

@Component({
    selector: "pcg-ng-directory-item-details-card",
    templateUrl: "./directory-item-details-card.component.html"
})
export class DirectoryItemDetailsCardComponent implements OnInit {
    @Input() public itemToDisplay: DirectoryItemModel;
    @Input() public viewPageUrl: string;
    @Input() public defaultImageUrl: string;

    public directoryItem$: BehaviorSubject<DirectoryItemModel>;
    public iss4sLoading: boolean = false;
    public isImageLoading = true;
    public isUpcomingOccurrencesOpen = false;

    public constructor(
        private googleMapService: GoogleMapService
    ) {
    }

    public ngOnInit(): void {
        this.directoryItem$ = new BehaviorSubject<DirectoryItemModel>(this.itemToDisplay);

        this.iss4sLoading = false;

        if (this.itemToDisplay) {
            this.googleMapService.addMarker(this.itemToDisplay, this.viewPageUrl);
        }
    }

    public getDetailsPageUrl(): string {
        if (!this.itemToDisplay || !this.viewPageUrl) return "#";

        const url = new URL(this.viewPageUrl, window.location.origin);
        url.searchParams.set("id", this.itemToDisplay.id);
        url.searchParams.set("returnUrl", window.location.href);

        return url.href;
    }

    public imageLoaded(): void {
        this.isImageLoading = false;
    }

    public toggleUpcomingOccurrences(): void {
        this.isUpcomingOccurrencesOpen = !this.isUpcomingOccurrencesOpen;
    }

    public getUpcomingOccurrences(item: DirectoryItemModel): Array<string> {
        return item.upcomingOccurrences
            .filter(occ => occ !== item.nearestOccurrence)
            .slice(0, 10);
    }

    public formatOccurrence(date: string, startTime?: number, endTime?: number): string {
        const d = new Date(date);
        const day = d.getDate();
        const ordinal = this.getOrdinal(day);
        const dayName = d.toLocaleDateString("en-GB", { weekday: "long" });
        const month = d.toLocaleDateString("en-GB", { month: "long" });
        const year = d.getFullYear();

        const dateStr = `${dayName} ${day}${ordinal} ${month} ${year}`;

        const hasStart = startTime !== null && startTime !== 0;
        const hasEnd = endTime !== null && endTime !== 0;
        const isSameTime = startTime === endTime;

        if (!hasStart) return dateStr;

        const timeStr = hasEnd && !isSameTime
            ? `${this.minsToTime(startTime)} - ${this.minsToTime(endTime)}`
            : this.minsToTime(startTime);

        return `${dateStr}, ${timeStr}`;
    }

    private getOrdinal(day: number): string {
        if (day > 3 && day < 21) return "th";
        switch (day % 10) {
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    }

    private minsToTime(minutes: number): string {
        const h = Math.floor(minutes / 60);
        const m = (minutes % 60).toString().padStart(2, "0");
        const suffix = h >= 12 ? "pm" : "am";
        const hour = (h % 12 || 12).toString();
        return `${hour}:${m}${suffix}`;
    }
}
